import { getCurrentScope, onScopeDispose, type Ref } from 'vue';
import { getMindboxSerpFields, mindbox } from '@/entities/analytics';
import type { ProductSearch, ProductSearchEvents } from '@/entities/product';
import type { SerpProduct } from './types';
import { SERP_MINDBOX_TYPES } from '../config/mindbox';
import {
  getSerpMindboxClickFields,
  isGroupSearch,
  isGroupSerpProduct,
  type SerpMindboxHotelOpen,
} from '../lib/serpMindbox';
import { hasSearchCountry } from '../lib/serpTracking';

interface SerpMindboxOptions {
  userSearchUuid: Readonly<Ref<string | null>>;
}

export interface UseSerpMindbox {
  trackHotelOpen(serpProduct: SerpProduct, hotelOpen: SerpMindboxHotelOpen): void;
}

export function useSerpMindbox(productSearch: ProductSearch, { userSearchUuid }: SerpMindboxOptions): UseSerpMindbox {
  const serpType = SERP_MINDBOX_TYPES[productSearch.type];

  const trackHotelOpen = (serpProduct: SerpProduct, hotelOpen: SerpMindboxHotelOpen): void => {
    const searchCriteria = hotelOpen.searchCriteria ?? hotelOpen.criteria;

    if (!serpType || isGroupSerpProduct(serpProduct) || !hasSearchCountry(searchCriteria)) return;

    mindbox.viewCategory(getSerpMindboxClickFields(serpType, hotelOpen));
  };

  if (!serpType) return { trackHotelOpen };

  const onStart = ({ searchUuid, criteria }: ProductSearchEvents['start']): void => {
    if (searchUuid !== userSearchUuid.value || !hasSearchCountry(criteria) || isGroupSearch(criteria)) return;

    mindbox.viewCategory(getMindboxSerpFields(serpType, criteria));
  };

  const unsubscribe = productSearch.on('start', onStart);

  if (getCurrentScope()) onScopeDispose(unsubscribe);

  return { trackHotelOpen };
}
